<template>
  <div class="com-box">
    <img class="img" v-if="!imgList.length" src="https://img3.quanyou.com.cn/joyNew/group1/M00/1D/0F/rB8LrWUxKHmAKMHZAADTENZIWyY761.png" alt="" />
    <template v-else>
      <div class="img-box" v-for="item in imgList" :key="item.moduleDetailValue">
        <van-image v-if="item.detailDataType == 1" 
          width="100%" 
          height="auto" 
          :src="item.moduleDetailValue" 
          fit="cover" />
        <video v-else-if="item.detailDataType == 2"
          :src="item.moduleDetailValue" controls="controls" 
          x5-video-player-type="h5-page" 
          x5-video-player-fullscreen="false" 
          x5-playsinline="" 
          playsinline=""
          webkit-playsinline="true"></video>
      </div>
    </template>
  </div>
</template>

<script>
import mixins from './mixins'
export default {
  mixins: [mixins]
}
</script>

<style lang="stylus" scoped>
  .com-box {
    .img {
      width: 100%;
      height: 230px;
    }
    .img-box {
      video {
        width 100%
        height 194px
        background #000
      }
       
    }
  }
</style>